import { IntrinsicTypes, } from '@sharefile/domino-types';
export const getIsBlueprintDerivedFlow = (spec) => {
    return spec.blueprintRef !== undefined;
};
export const getIsFlowDefinition = (def) => {
    return def.flow !== undefined;
};
export const getIsBlueprintDefinition = (def) => {
    return def.blueprint !== undefined;
};
export const getIsActionDefinition = (def) => {
    return def.action !== undefined;
};
export const getIsTriggerDefinition = (def) => {
    return def.trigger !== undefined;
};
export const getIsTypeDefinition = (def) => {
    return def.type !== undefined;
};
export const getIsNamedTriggerCall = (trigger) => {
    return trigger.name !== undefined;
};
export const getIsTriggerGenericTyped = (trigger) => {
    return (trigger.genericTypeArgs !==
        undefined);
};
export const getIsIntrinsicType = (type) => {
    return Object.values(IntrinsicTypes).includes(type);
};
export const getIsAnyType = (type) => {
    return !Array.isArray(type);
};
//# sourceMappingURL=typeGuards.js.map